var _defs, _polygon, _circle, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle2, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnwaelte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f2e41;}.cls-2{fill:#ffb8b8;}.cls-3{fill:#137f7b;}.cls-4{fill:#3f3d56;}.cls-5{fill:#ffb7b7;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.53 265.5 86.53 449.17 91.18 567.75 129.54 567.75 142.33 344.55 167.9 436.39 184.18 565.43 230.68 563.1 199.29 265.5 86.53 265.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 131.12,
    cy: 72.51,
    r: 27.9
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "119.53 107.68 112.1 115.53 105.13 272.47 187.66 270.14 167.9 132.97 150.47 116.26 141.62 107.68 119.53 107.68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.29,124.83l6.26-10.17,1.88,21.79s15.11,48.83,13.95,91.84,5.81,144.16-3.49,145.32S76.06,377.1,76.06,369s-2.32-224.37-2.32-224.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.59,114.66l15.82,12.49,34.88,12.79s0,148.8,7,183.68S226,362,209.75,363.15s-15.11-4.65-15.11-4.65,11.63-58.13-3.49-69.76S147,209.69,149.3,172.49,146.27,114.66,148.59,114.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.73,81.24s2.37-4.16,1.82-18.07,20.62-6,38.32-7.36S158.82,79,158.82,79s1.28-1.45,4-13.3-3.47-23.65-3.47-23.65c-1.83-12.45-11.68-8.46-11.68-8.46,4.74,1.85,3.83,5.79,3.83,5.79-4-7-13.87-3-13.87-3C124.51,28.11,111.19,39,111.19,39c-15.87,3.6-6.56,16.22-6.56,16.22C88.67,63.26,104.73,81.24,104.73,81.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.55,144.59l-3.09-1.65S59.79,149.24,61,153.89s-9.3,167.41-5.81,173.22,31.39,1.16,31.39,1.16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M212.26,341.19a11.77,11.77,0,0,1-1.84-16.54,11.92,11.92,0,0,1,1.43-1.5l-8.63-25.47,14.2-9L229.1,324.8a11.83,11.83,0,0,1-16.84,16.39Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.64,319s28.27.74,30.92-5.5-30.23-166-29.72-170.75S183,134,183,134l-2.83,2.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M323.61,326.17,306.1,240.39,298.41,177l-17,11,2.36,69.82,27.19,72.34a9.48,9.48,0,1,0,12.8-4l-.11-.06Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M159.88,332.81l4.84-87.42-1.6-63.8L185.64,190l3.76,69.42L173,335a9.48,9.48,0,1,1-13.25-2.08l.11-.07Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.67,573.69l-.06-.32L162,348.12a85.15,85.15,0,0,1,7.51-53.22l25.22-50.43,75.25,10.2,8.88,64.2,31.64,122.49,0,.1L269.87,570.25,243.3,572l23.54-115-43.1-97.9,3,212.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M271.68,262.88l-.5-.78c-.09-.14-9.23-13.91-34.1-4.71-25.39,9.39-45.06-8.75-45.26-8.93l-.1-.09L186,197.12l-6.79-41.61,21.61-3.79,10.63-6.37,42.24-.75,11.11,8.74,18.25,2,1.68,37.91v0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277.73,196.91V164.44l5.13-9.36h.21a15.4,15.4,0,0,1,10.63,4.83c5.16,5.25,7.5,14,6.95,26v.22Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.28,193.38l-26.16-3.14,0-.3c-.89-13.05,1.38-22.73,6.77-28.78a16.55,16.55,0,0,1,10.72-5.84h.15l7.08,6.44Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264,131.52H195.17a5.35,5.35,0,0,1-5.34-5.34V101.25a39.76,39.76,0,0,1,79.51-.11v25A5.35,5.35,0,0,1,264,131.52Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 231.18,
    cy: 102.12,
    r: 29.15
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.89,103H220.4a3,3,0,0,1-2.94-2.59l-.5-4a1.78,1.78,0,0,0-2-1.55,1.79,1.79,0,0,0-1.4,1l-2.52,5.4a3,3,0,0,1-2.69,1.71h-5.84a3,3,0,0,1-3-3,2.53,2.53,0,0,1,0-.28l2.31-24.08a3,3,0,0,1,1.69-2.42c17.63-8.22,35.5-8.21,53.12,0a3,3,0,0,1,1.68,2.27l3.45,24.05a3,3,0,0,1-2.93,3.38Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnwaelte);
export default __webpack_public_path__ + "static/media/Anwaelte.fd73e4544dcac64a2b1f8d86886376a1.svg";
export { ForwardRef as ReactComponent };